import { createSelector } from "reselect"
import { getReimbursementsList } from "../reducers/reimbursements"
import { CardExpenseStatus, ExpenseStatus } from "utils/ExpenseStatuses"

export const getReimbursementsRequiringActionList = createSelector([getReimbursementsList], (reimbursements) => {
  return reimbursements.filter(
    (x) =>
      x.isCardExpense &&
      (x.cardStatus === CardExpenseStatus.DENIED_RECONCILIATION_REQUESTED ||
        x.cardStatus === CardExpenseStatus.PENDING_MEMBER_INFO)
  )
})

export const getPendingReimbursementsList = createSelector([getReimbursementsList], (reimbursements) => {
  return reimbursements.filter(
    (x) =>
      (!x.isCardExpense && (x.status === ExpenseStatus.RECEIVED || x.status === ExpenseStatus.APPROVED)) ||
      (x.isCardExpense && x.cardStatus === CardExpenseStatus.PENDING_CARE_NAV)
  )
})

export const getCompletedReimbursementsList = createSelector([getReimbursementsList], (reimbursements) => {
  return reimbursements.filter(
    (x) =>
      (!x.isCardExpense && (x.status === ExpenseStatus.DENIED || x.status === ExpenseStatus.PAID)) ||
      (x.isCardExpense &&
        (x.cardStatus === ExpenseStatus.APPROVED || x.cardStatus === CardExpenseStatus.DENIED_RECONCILED))
  )
})
